/*!

=========================================================
* Paper Dashboard React - v1.3.0
=========================================================

* Product Page: https://www.creative-tim.com/product/paper-dashboard-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

* Licensed under MIT (https://github.com/creativetimofficial/paper-dashboard-react/blob/main/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, {useState, useEffect } from "react";
import gameImg from "assets/img/ball.png";

import { useHistory } from 'react-router-dom';
// import PlayerList from './PlayerList.js';
import { Input } from "reactstrap";

// reactstrap components
import NotificationAlert from "react-notification-alert";
import {  
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  Form,
  Row,
  Col,
} from "reactstrap";

let axios = require('axios');
let URL_API = "https://xs458763.xsrv.jp/api/";
var aTimeout = null;
// let session = window.sessionStorage.getItem('sessions'); 
// let se = JSON.parse(session);

let notificationAlert;

function GoalSetting() {

  notificationAlert = React.useRef();  
  
  const [goalsetting, s_setGoalsetting] = useState([]);
  const [playerIndex, setPlayerIndex] = useState(0);
  const [uFlag, setUFlag] = useState(true);
  //const [p_opponent, s_setOpponentData] = useState([]);
  
  const history = useHistory();

  const getViewpageUrl = (tmp) => {

    window.sessionStorage.setItem('goal', JSON.stringify(tmp)); 
    history.push('../parent/goalsettingedit');

  };
  
  useEffect(() => {    
    // session = window.sessionStorage.getItem('sessions'); 
    // se = JSON.parse(session);
    let session = window.sessionStorage.getItem('player'); 
    let se = JSON.parse(session);
    if(!se){
      return;
    }
    axios.get(URL_API+"getGoalSettingAPI", {
      params: {
        sel: se['id'], 
      }
    })
    .then(function (response) {
      if(Array.isArray(response.data)){
        s_setGoalsetting(response.data);
      }

    }); 
       

  }, [uFlag]);
 

  return (
    <>
      <Col className="col-12 mt-2">                                         
        {
          goalsetting?.map((tmp, index) => 

          <Row className="py-1" key={index} onClick={() => getViewpageUrl(tmp)} val={tmp.id}> 
            <Col className="col-2" style={{color:'rgb(3, 115, 202)', fontSize:'16px', paddingRight:'0px', textAlign: 'center'}}>
              <img src={gameImg}  width="30px"/>
            </Col>                        
            <Col className="col-10 text-left d-flex align-items-center" style={{color:'rgb(3, 115, 202)', fontSize:'16px'}}>
              <b>{tmp.edit_date}</b>
            </Col>                          
          </Row>
          )
        } 
      </Col>
    </>
  );
}


export default GoalSetting;
